import "../styles/App.css";
import "../styles/pages/Events.css";

import Header from "../components/Header";
import ImageCard from "../components/ImageCard";
import useIsMobile from "../hooks/useIsMobile";
import Carousel from "../components/ImageCarousel";

type Event = {
  icon: string;
  content: string[];
  link?: string;
};

const events: Event[] = [
  {
    icon: "/images/events1.png",
    content: [
      "A Dra Mariana, em representação da MNR - Clínica de Psicologia, celebra uma parceria com a Associação Aragens D'Empatia.",
    ],
  },
  {
    icon: "/images/events2.png",
    content: [
      "A MNR - Clínica de Psicologia, representada pela Dra. Mariana e pela Enfermeira Célia de Magalhães, estará presente na conferência Reflexões sobre Parentalidade e Família, a apresentar o Programa de Parentalidade Reflexiva.",
    ],
    link: "https://drive.google.com/file/d/1wUQpZ688WhOtU3W2EwJyKx5EJxzQb5iA/view"
  },
];



function Events() {
  const isMobile = useIsMobile(801);
  const eventsRender = events.map((ev) => <ImageCard link={ev.link} icon={ev.icon} content={ev.content} />);
  return (
    <div id="events" className="section" style={{ background: "#FFFFFF" }}>
      <div className="eventsWrapper">
        <Header content="Parcerias e Eventos" />        
        {isMobile? <Carousel items={eventsRender} slideInterval={0}/> : <div className="cardWrapper"> {eventsRender} </div>}
      </div>
    </div>
  );
}

export default Events;
